export default __webpack_public_path__ + "static/media/featuredRaceBg.4a6b7ed8.png";